const COOKIE_NOTICE_KEY = "guestqueue_policy_notice_v1";

const initCookieNotice = () => {
    const notice = document.querySelector("#cookieNotice");
    const acceptButton = document.querySelector("#cookieNoticeAccept");

    if (!notice || !acceptButton) {
        return;
    }

    const accepted =
        localStorage.getItem(COOKIE_NOTICE_KEY) === "true";

    if (!accepted) {
        notice.hidden = false;
    }

    acceptButton.addEventListener("click", () => {
        localStorage.setItem(COOKIE_NOTICE_KEY, "true");
        notice.hidden = true;
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCookieNotice);
} else {
    initCookieNotice();
}